import { render, staticRenderFns } from "./AutomatedKDB.vue?vue&type=template&id=e96c0500&"
import script from "./AutomatedKDB.vue?vue&type=script&lang=js&"
export * from "./AutomatedKDB.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedKDB.vue?vue&type=style&index=0&id=e96c0500&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports